<app-menu>
    <div class="consolidator-container">
      <div [attr.inert]="isSaving || pendingConsolidationRequest ? '' : null">
      <!-- Search Bar -->
      <div class="search-bar">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Search</mat-label>
          <input
            matInput
            [(ngModel)]="searchQuery"
            (input)="filterLadings()"
            placeholder="Search by Order No, Consignee, etc."
          />
        </mat-form-field>
      </div>
  
      <!-- Ladings Table -->
      <div class="table-container">
        <table mat-table [dataSource]="filteredLadings" class="mat-elevation-z8 ladings-table">
          <!-- Order No. Column -->
          <ng-container matColumnDef="order_no">
            <th mat-header-cell *matHeaderCellDef> Order No. </th>
            <td mat-cell *matCellDef="let lading">
              {{ lading.alternate_reference }}
            </td>
          </ng-container>
  
          <!-- Shipper Name Column -->
          <ng-container matColumnDef="shipper_name">
            <th mat-header-cell *matHeaderCellDef> Shipper </th>
            <td mat-cell *matCellDef="let lading">
              {{ lading.shipper_name }}
            </td>
          </ng-container>
  
          <!-- Shipper Location Column -->
          <ng-container matColumnDef="shipper_location">
            <th mat-header-cell *matHeaderCellDef> Shipper Location </th>
            <td mat-cell *matCellDef="let lading">
              {{ lading.shipper_locality }}, {{ lading.shipper_region }}
            </td>
          </ng-container>
  
          <!-- Consignee Name Column -->
          <ng-container matColumnDef="consignee_name">
            <th mat-header-cell *matHeaderCellDef> Consignee </th>
            <td mat-cell *matCellDef="let lading">
              {{ lading.consignee_name }}
            </td>
          </ng-container>
  
          <!-- Consignee Location Column -->
          <ng-container matColumnDef="consignee_location">
            <th mat-header-cell *matHeaderCellDef> Consignee Location </th>
            <td mat-cell *matCellDef="let lading">
              {{ lading.consignee_locality }}, {{ lading.consignee_region }}
            </td>
          </ng-container>
  
          <!-- Load Weight Column -->
          <ng-container matColumnDef="load_weight">
            <th mat-header-cell *matHeaderCellDef> Weight </th>
            <td mat-cell *matCellDef="let lading">
              {{ lading.load_weight }}
            </td>
          </ng-container>
  
          <!-- Load Pieces Column -->
          <ng-container matColumnDef="load_pieces">
            <th mat-header-cell *matHeaderCellDef> Pieces </th>
            <td mat-cell *matCellDef="let lading">
              {{ lading.load_pieces }}
            </td>
          </ng-container>
  
          <!-- Load Pallets Column -->
          <ng-container matColumnDef="load_pallets">
            <th mat-header-cell *matHeaderCellDef> Pallets </th>
            <td mat-cell *matCellDef="let lading">
              {{ lading.load_pallets }}
            </td>
          </ng-container>

          <!-- Load Pallets Column -->
          <ng-container matColumnDef="load_length">
            <th mat-header-cell *matHeaderCellDef> Length </th>
            <td mat-cell *matCellDef="let lading">
              {{ lading.load_length }}
            </td>
          </ng-container>
  
          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Actions </th>
            <td mat-cell *matCellDef="let lading" class="actions-cell">
              <button mat-raised-button color="primary" (click)="addToConsolidation(lading)">
                Add
              </button>
              <button
                mat-icon-button
                [matMenuTriggerFor]="addOptionsMenu"
                class="options-button"
                aria-label="More options"
              >
                <i class="fas fa-ellipsis-h"></i>
              </button>
              <mat-menu #addOptionsMenu="matMenu">
                <button mat-menu-item (click)="addToConsolidationAsOwnStop(lading)">
                  <i class="fas fa-plus"></i>
                  Add as Own Stop
                </button>
              </mat-menu>
            </td>
          </ng-container>
  
          <!-- Header and Row Declarations -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" class="ladings-row"></tr>
        </table>
      </div>
  
      <!-- Consolidation Section -->
      <div class="consolidation-section" *ngIf="consolidationStops.length > 0">
        <!-- Master Lading Display -->
        <div class="master-lading">
          <h3 class="section-title">Master Lading</h3>
          <div class="master-details">
            <div class="master-field">
              <span class="label">Shipper:</span>
              <mat-form-field appearance="outline" class="shipper-dropdown">
                <mat-label>Select Shipper</mat-label>
                <mat-select [(value)]="selectedShipper" (selectionChange)="handleShipperChange($event)">
                  <mat-option *ngFor="let terminal of terminals" [value]="terminal">
                    {{ terminal.terminal_name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
             <!-- Carrier Field -->
            <div class="master-field">
              <span class="label">Carrier:</span>
              <mat-form-field appearance="outline" class="carrier-dropdown">
                <mat-select
                  #carrierSelect
                  placeholder="Select Carrier"
                  [(value)]="selectedCarrier"
                  (selectionChange)="handleCarrierChange()"
                  panelClass="carrier-select-panel"
                >
                  <!-- Search Input Field -->
                  <mat-option>
                    <input
                      matInput
                      placeholder="Search Carriers"
                      [(ngModel)]="carrierFilter"
                      (keyup)="filterCarriers()"
                      (click)="$event.stopPropagation()"
                    />
                  </mat-option>
                  <!-- Divider -->
                  <mat-divider></mat-divider>
                  <!-- Carrier Options -->
                  <mat-option
                    *ngFor="let carrier of filteredCarriers"
                    [value]="carrier"
                  >
                    {{ carrier.carrier_name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="master-field">
              <span class="label">Shipper Location:</span>
              <span>{{ masterShipper.locality }}, {{ masterShipper.region }}</span>
            </div>
            <div class="master-field">
              <span class="label">Consignee:</span>
              <span>{{ masterLading.consignee }}</span>
            </div>
            <div class="master-field">
              <span class="label">Consignee Location:</span>
              <span>{{ masterLading.consigneeContact.locality }}, {{ masterLading.consigneeContact.region }}</span>
            </div>
            <div class="master-field">
              <span class="label">Total Load Pieces:</span>
              <span>{{ masterLading.totalLoadPieces }}</span>
            </div>
            <div class="master-field">
              <span class="label">Total Load Weight:</span>
              <span>{{ masterLading.totalLoadWeight }}</span>
            </div>
            <div class="master-field">
              <span class="label">Total Load Pallets:</span>
              <span>{{ masterLading.totalLoadPallets }}</span>
            </div>
            <div class="master-field">
              <span class="label">Total Load Length:</span>
              <span>{{ masterLading.totalLoadLength }}</span>
            </div>
          </div>
        </div>
  
        <h3>Consolidation Stops</h3>
        <!-- Auto Stops Button -->
        <div class="auto-stops-button" *ngIf="consolidationStops.length > 1">
          <button mat-raised-button color="accent" (click)="autoSortStops()">
            <i class="fas fa-sync-alt"></i> Auto Stops
          </button>
        </div>
        <div class="stops-table-container">
          <table
            mat-table
            [dataSource]="stopsDataSource"
            class="stops-table mat-elevation-z8"
            multiTemplateDataRows
          >
            <!-- Expand/Collapse Column -->
            <ng-container matColumnDef="expand">
              <th mat-header-cell *matHeaderCellDef> Expand </th>
              <td mat-cell *matCellDef="let stop">
                <button
                  mat-icon-button
                  color="primary"
                  (click)="toggleExpand(stop)"
                  [attr.aria-label]="'Toggle ' + stop.consignee"
                >
                  <i class="fas" [ngClass]="expandedElement === stop ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </button>
              </td>
            </ng-container>
  
            <!-- Stop Number Column -->
            <ng-container matColumnDef="stopNumber">
              <th mat-header-cell *matHeaderCellDef> Stop # </th>
              <td mat-cell *matCellDef="let stop">
                {{ stop.stopNumber }}
              </td>
            </ng-container>
  
            <!-- Shipper Column -->
            <ng-container matColumnDef="shipper">
              <th mat-header-cell *matHeaderCellDef> Shipper </th>
              <td mat-cell *matCellDef="let stop">
                {{ stop.shipper }}
              </td>
            </ng-container>
  
            <!-- Shipper Location Column -->
            <ng-container matColumnDef="shipper_location">
              <th mat-header-cell *matHeaderCellDef> Shipper Location </th>
              <td mat-cell *matCellDef="let stop">
                {{ stop.shipperContact.locality }}, {{ stop.shipperContact.region }}
              </td>
            </ng-container>
  
            <!-- Consignee Column -->
            <ng-container matColumnDef="consignee">
              <th mat-header-cell *matHeaderCellDef> Consignee </th>
              <td mat-cell *matCellDef="let stop">
                <mat-form-field appearance="outline">
                  <mat-label>Select Consignee</mat-label>
                  <mat-select [(value)]="stop.selectedConsignee" (selectionChange)="handleConsigneeChange($event, stop)">
                    <mat-option *ngFor="let consignee of terminals" [value]="consignee">
                      {{ consignee.terminal_name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
            </ng-container>
  
            <!-- Consignee Location Column -->
            <ng-container matColumnDef="consignee_location">
              <th mat-header-cell *matHeaderCellDef> Consignee Location </th>
              <td mat-cell *matCellDef="let stop">
                <ng-container *ngIf="stop.selectedConsignee; else displayOriginalLocation">
                  {{ stop.selectedConsignee.address_locality }}, {{ stop.selectedConsignee.address_region }}
                </ng-container>
                <ng-template #displayOriginalLocation>
                  {{ stop.consigneeContact.locality }}, {{ stop.consigneeContact.region }}
                </ng-template>
              </td>
            </ng-container>
  
            <!-- Total Load Pieces Column -->
            <ng-container matColumnDef="totalLoadPieces">
              <th mat-header-cell *matHeaderCellDef> Total Pieces </th>
              <td mat-cell *matCellDef="let stop">
                {{ stop.totalLoadPieces }}
              </td>
            </ng-container>
  
            <!-- Total Load Weight Column -->
            <ng-container matColumnDef="totalLoadWeight">
              <th mat-header-cell *matHeaderCellDef> Total Weight </th>
              <td mat-cell *matCellDef="let stop">
                {{ stop.totalLoadWeight }}
              </td>
            </ng-container>
  
            <!-- Total Load Pallets Column -->
            <ng-container matColumnDef="totalLoadPallets">
              <th mat-header-cell *matHeaderCellDef> Total Pallets </th>
              <td mat-cell *matCellDef="let stop">
                {{ stop.totalLoadPallets }}
              </td>
            </ng-container>

            <!-- Total Load Length Column -->
            <ng-container matColumnDef="totalLoadLength">
              <th mat-header-cell *matHeaderCellDef> Total Length </th>
              <td mat-cell *matCellDef="let stop">
                {{ stop.totalLoadLength }}
              </td>
            </ng-container>
  
            <!-- Number of Ladings Column -->
            <ng-container matColumnDef="numLadings">
              <th mat-header-cell *matHeaderCellDef> # of Ladings </th>
              <td mat-cell *matCellDef="let stop">
                {{ stop.ladings.length }}
              </td>
            </ng-container>
  
            <!-- Actions Column (Reordering) -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef> Actions </th>
              <td mat-cell *matCellDef="let stop">
                <button
                  class="action-button"
                  (click)="moveStopUp(stop)"
                  [disabled]="consolidationStops.indexOf(stop) === 0"
                  aria-label="Move Stop Up"
                >
                  <i class="fas fa-arrow-up"></i>
                </button>
                <button
                  class="action-button"
                  (click)="moveStopDown(stop)"
                  [disabled]="consolidationStops.indexOf(stop) === (consolidationStops.length - 1)"
                  aria-label="Move Stop Down"
                >
                  <i class="fas fa-arrow-down"></i>
                </button>
              </td>
            </ng-container>
  
            <!-- Expanded Row Content -->
              <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let stop" [attr.colspan]="stopColumns.length">
                  <div class="expanded-detail" [class.show]="expandedElement === stop">
                    <h4>Ladings</h4>
                    <table mat-table [dataSource]="stop.ladingsDataSource"  class="inner-ladings-table mat-elevation-z1">
                      <!-- Order No. Column -->
                      <ng-container matColumnDef="order_no">
                        <th mat-header-cell *matHeaderCellDef> Order No. </th>
                        <td mat-cell *matCellDef="let lading">
                          {{ lading.alternate_reference }}
                        </td>
                      </ng-container>

                      <!-- Weight Column -->
                      <ng-container matColumnDef="load_weight">
                        <th mat-header-cell *matHeaderCellDef> Weight </th>
                        <td mat-cell *matCellDef="let lading">
                          {{ lading.load_weight }}
                        </td>
                      </ng-container>

                      <!-- Pieces Column -->
                      <ng-container matColumnDef="load_pieces">
                        <th mat-header-cell *matHeaderCellDef> Pieces </th>
                        <td mat-cell *matCellDef="let lading">
                          {{ lading.load_pieces }}
                        </td>
                      </ng-container>

                      <!-- length Column -->
                      <ng-container matColumnDef="load_length">
                        <th mat-header-cell *matHeaderCellDef> Length </th>
                        <td mat-cell *matCellDef="let lading">
                          {{ lading.load_length }}
                        </td>
                      </ng-container>

                      <!-- Actions Column -->
                      <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef> Actions </th>
                        <td mat-cell *matCellDef="let lading">
                          <button
                            mat-icon-button
                            [matMenuTriggerFor]="ladingMenu"
                            [attr.aria-label]="'Options for ' + lading.alternate_reference"
                          >
                            <i class="fas fa-ellipsis-v"></i>
                          </button>
                          <mat-menu #ladingMenu="matMenu">
                            <button mat-menu-item (click)="removeFromConsolidation(lading, stop)">
                              <i class="fas fa-trash-alt"></i>
                              Remove
                            </button>
                            <button mat-menu-item (click)="moveLadingToAnotherStop(lading, stop)">
                              <i class="fas fa-exchange-alt"></i>
                              Move to Another Stop
                            </button>
                            <button mat-menu-item (click)="makeLadingItsOwnStop(lading, stop)">
                              <i class="fas fa-plus"></i>
                              Make its Own Stop
                            </button>
                          </mat-menu>
                        </td>
                      </ng-container>

                      <!-- Header and Row Declarations -->
                      <tr mat-header-row *matHeaderRowDef="['order_no', 'load_weight', 'load_pieces', 'actions']"></tr>
                      <tr mat-row *matRowDef="let row; columns: ['order_no', 'load_weight', 'load_pieces', 'actions']"></tr>
                    </table>
                  </div>
                </td>
              </ng-container>
  
            <!-- Header Row -->
            <tr mat-header-row *matHeaderRowDef="stopColumns; sticky: true"></tr>
  
            <!-- Data Rows -->
            <tr
              mat-row
              *matRowDef="let row; columns: stopColumns"
              class="stop-row"
              [class.expanded]="expandedElement === row"
            ></tr>
  
            <!-- Expanded Detail Rows -->
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expanded-row"></tr>
          </table>
        </div>
  
      </div>
      </div>
      <p *ngIf="consolidationMessage" role="status">{{ consolidationMessage }}</p>
      <div class="consolidation-actions" *ngIf="consolidationStops.length || pendingConsolidationRequest">
        <button mat-raised-button color="primary" [disabled]="isSaving || !recoveryReady" (click)="saveConsolidation()">
          {{ isSaving ? 'Checking…' : pendingConsolidationRequest ? 'Check save status' : 'Save Consolidation' }}
        </button>
      </div>
    </div>
  </app-menu>
